import * as React from "react";
import AreaMain from "./area/AreaMain";

const App = () => {
    return <AreaMain/>;
}

export default App;